import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { createSellerEvent, editSellerEvent } from '../../../_events/sellers/create_seller.event';
import { findAllSellerByCompanyEvent } from '../../../_events/sellers/find_sellers.event';
import { message } from "antd";
import { ROLES } from "../../../_config/roles";
import RolWrapper from "../../hoc/roles_wrapper";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin]);

const Sellers = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'seller_cod', headerName: 'Código', width: 200 },
        { field: 'full_name', headerName: 'Nombre', width: 200 },
        { field: 'login', headerName: 'Usuario', width: 200 },
        { field: 'state.cod', headerName: 'Estado', width: 100, sortable: false,
            renderCell: (params) => {
                return <span style={params.row.state?.cod === 'ACTI' ? {color: 'green'} : {}}>{params.row.state?.name}</span>;
            }
        },
        { field: '', headerName: 'Acciones', width: 100, sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem(params.row); setRender('form');
                };    
                return <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>;
            }
        },
    ];

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Vendedores
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'100%'}}>
                        {
                            render === 'info' ? 
                            <ButtonRolAuthComponent onClick={() => {setItem(null);setRender('form');}} variant="contained">Crear nuevo</ButtonRolAuthComponent>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                {
                    render === 'info' ? <SellerInfo columns={columns} /> : <SellerForm item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const SellerInfo = (props) => {

    const [sellers, setSellers] = useState([]);

    const findSellers = () => {
        findAllSellerByCompanyEvent()
        .then(data => {
            setSellers(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findSellers();
    }, []);   

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={sellers}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

const SellerForm = (props) => {
    let { item } = props; 

    const createSeller = () => {
        createSellerEvent()
        .then(data => {
            message.success('Creado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const editSeller = (id) => {
        editSellerEvent(id)
        .then(data => {
            message.success('Actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="seller_cod" 
                        label="Código de vendedor" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.seller_cod : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="seller_full_name" 
                        label="Nombre completo" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.full_name : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="seller_login" 
                        label="Usario en el sistema" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.login : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        type={'password'}
                        style={{width: '100%'}} 
                        id="seller_password" 
                        label="Contraseña" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.password : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editSeller(item.uuid)} variant="contained">Editar</Button>
                        : <Button style={{width: '100%'}} onClick={() => createSeller()} variant="contained">Guardar</Button>
                    }      
                </Grid>                
            </Grid>
        </div>
    );
}

export default Sellers;